import type { User } from "./user";

/**
 * ドキュメントタイプの表示名マッピング
 *
 * 【プロジェクト標準】kebab-caseを使用
 */
export const documentNameMap = {
  transcription: "アップロード",
  summary: "議事録",
  "system-proposal": "システム概要書",
  estimation: "概算工数見積書",
  "cost-effectiveness": "費用対効果",
  "functional-requirements": "機能要件書",
  "non-functional-requirements": "非機能要件書",
  workflow: "業務フロー図",
  "app-design": "アプリ設計書",
  "plugin-proposal": "プラグイン提案書",
  "field-design": "フィールド設計書",
  "entity-relationship": "ER図",
  "system-architecture": "システム構成図",
  "customize-specification": "カスタマイズ仕様書",
  "sample-app": "サンプルアプリ",
} as const;

/**
 * ドキュメントタイプ（kebab-case）
 *
 * 【プロジェクト標準】コンポーネントのProps、API通信、ルーティングで使用
 * documentNameMapのキーから派生
 *
 * @example 'summary' | 'system-proposal' | 'estimation' | ...
 */
export type DocumentType = keyof typeof documentNameMap;

/**
 * 全てのドキュメントタイプの配列
 */
export const DOCUMENT_TYPES_LIST: DocumentType[] = Object.keys(documentNameMap) as DocumentType[];

/**
 * ドキュメントタイプの表示名を取得
 *
 * @param type - DocumentType (kebab-case)
 * @returns 表示名（日本語）
 *
 * @example
 * getDocumentTypeName('system-proposal') // => 'システム概要書'
 */
export const getDocumentTypeName = (type: DocumentType): string => {
  return documentNameMap[type] ?? "";
};

// New
export interface Document {
  id: string;
  project_id: string;
  organization_id: string;
  type: DocumentType;
  name: string;
  content: string;
  sources: {
    type: string;
    id: string;
  }[];
  created_at: string;
  modified_at?: string;
  modified_by?: User;
  expires_at: string;
  status: "upload" | "generate" | "edit" | "rollback";
  meeting?: {
    date?: string;
    url?: string;
  };
}

export interface UpdateDocumentData {
  name?: string;
  meeting?: {
    date?: string;
    url?: string;
  };
}

export interface UpdateDocumentContent {
  content: string;
}

export interface ExportDocument {
  document_type: string;
}

export interface UpdateDocumentStatus {
  type: string;
  status: boolean;
}
